import React, { FC, useState, useCallback, ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";

import { NewBankAccountModal, NewWalletModal } from "../../modals";
import { setVideoAskUrl } from "../../../store/reducers/ui";
import { CurrencyType } from "../../../types/InvoiceTypes";
import { toastSuccess } from "../../../utils/toasts";

type Props = {
  children: (fn: () => void) => ReactNode;
  callback?: (data?: any) => void;
  currencyType?: CurrencyType;
};

const successMessage = {
  [CurrencyType.CRYPTO]: "Wallet",
  [CurrencyType.FIAT]: "Bank account",
};

export const NewWalletAction: FC<Props> = ({
  children,
  callback,
  currencyType = CurrencyType.CRYPTO,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  // Video guide
  useEffect(() => {
    if (isOpen) {
      dispatch(setVideoAskUrl("https://www.videoask.com/fvxuz3dxi"));
    }

    return () => {
      dispatch(setVideoAskUrl(null));
    };
  }, [dispatch, isOpen]);

  const actionHandler = () => setIsOpen(true);

  const localCallback = useCallback(
    (data?: any) => {
      if (isOpen) {
        setIsOpen(false);
        toastSuccess(`${successMessage[currencyType]} added`);
        callback && callback(data);
      }
    },
    [isOpen, currencyType, callback]
  );

  return (
    <>
      {children(actionHandler)}

      {currencyType === CurrencyType.CRYPTO ? (
        <NewWalletModal
          isOpen={isOpen}
          close={() => setIsOpen(false)}
          callback={localCallback}
        />
      ) : (
        <NewBankAccountModal
          isOpen={isOpen}
          close={() => setIsOpen(false)}
          callback={localCallback}
        />
      )}
    </>
  );
};
